import { render, staticRenderFns } from "./reroute-rules.vue?vue&type=template&id=4fa1a84b&scoped=true&"
import script from "./reroute-rules.ts?vue&type=script&lang=ts&"
export * from "./reroute-rules.ts?vue&type=script&lang=ts&"
import style0 from "./reroute-rules.scss?vue&type=style&index=0&id=4fa1a84b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa1a84b",
  null
  
)

export default component.exports